const heroSliderInit = () => {
    const sliders = Array.from(document.querySelectorAll('.bn-hero-slider .swiper'));

    if (sliders) {
        sliders.forEach(slider => {
            if (slider) {
                const sliderConfig = {
                    observer: true,
                    observeSlideChildren: true,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                    },
                    slidesPerView: 1,
                    // pagination: {
                    //     el: '.swiper-pagination',
                    // },
                    allowTouchMove: slider.dataset.allowtouchmove === "0",
                    // navigation: {
                    //     nextEl: slider.parentNode.querySelector(".swiper-button-next"),
                    //     prevEl: slider.parentNode.querySelector(".swiper-button-prev"),
                    // }
                }

                let currentSlider = new Swiper(slider, sliderConfig);
                console.log(currentSlider);
                currentSlider.on( 'observerUpdate', () => {
                    currentSlider.destroy(currentSlider, true);
                    currentSlider = new Swiper(slider, sliderConfig);
                });
            }
        })
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        heroSliderInit();
});